import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

const defaultMessage = 'Algo deu errado! Tente novamente em instantes ou entre em contato com suporte.';
const ERROR_MESSAGE_DURATION = 20000;
export enum ErrorsEnum {
  OUT_ORDER_STATE_CONFLICT = 'OUT_ORDER-STATE_CONFLICT',
  GROUND_POSITION_INVALID_STATE_TRANSITION = 'GROUND_POSITION_INVALID_STATE_TRANSITION',
  NOT_ENOUGH_PRODUCTS_AT_PICKING = 'NOT_ENOUGH_PRODUCTS_AT_PICKING',
  NO_PALLETS_WITH_SKU_AT_PICKING = 'NO_PALLETS_WITH_SKU_AT_PICKING',
  TASK_EXISTING = 'TASK_EXISTING',
  PRODUCTS_FORBIDDEN_ACCESS = 'PRODUCTS_FORBIDDEN_ACCESS',
  PASSWORD_VALIDATION_FAILED = 'PASSWORD_VALIDATION_FAILED',
  USER_ERROR_EDIT_SELF_TYPE = 'USER_ERROR-EDIT_SELF_TYPE',
  USER_ERROR_INVALID_PERMISSION = 'USER_ERROR-INVALID_PERMISSION',
  USER_ERROR_INVALID_PASSWORD_PATTERN = 'USER_ERROR-INVALID_PASSWORD_PATTERN',
  USER_ERROR_USER_ALREADY_EXISTS = 'USER_ERROR-USER_ALREADY_EXISTS',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  GROUND_POSITION_ERROR_CONFLICT_TYPE = 'GROUND_POSITION_ERROR-CONFLICT_TYPE',
  TENANT_INDEPENDENT_LEVELS = "TENANT_INDEPENDENT_LEVELS",
  PACKING_ERROR_TASK_CONFLICT = "PACKING_ERROR-TASK_CONFLICT",
  OUT_ORDER_ERROR_INVALID_PRODUCT = "OUT_ORDER_ERROR-INVALID_PRODUCT",
  OUT_ORDER_ERROR_ALREADY_EXISTS = "OUT_ORDER_ERROR-ALREADY_EXISTS",
  PACKING_ERROR_PRODUCT_SHORTAGE = "PACKING_ERROR-PRODUCT_SHORTAGE",
  FORBIDDEN_ACTION_FOR_USER_TYPE = "FORBIDDEN_ACTION_FOR_USER_TYPE",
  GROUND_POSITION_WITH_TASK = "GROUND_POSITION_WITH_TASK",
  GROUND_POSITION_WITH_PALLET = "GROUND_POSITION_WITH_PALLET",
  PALLET_POSITION_CONFLICT = "PALLET_POSITION_CONFLICT",
  TENANT_PIGEONHOLE = "TENANT_PIGEONHOLE",
  GROUND_POSITION_NOT_FOUND = "GROUND_POSITION_NOT_FOUND",
  PIGEONHOLE_NOT_FOUND = "PIGEONHOLE_NOT_FOUND",
  PIGEONHOLE_WITH_PACKAGES = "PIGEONHOLE_WITH_PACKAGES",
  USER_ERROR_NOT_FOUND = "USER_ERROR-NOT_FOUND",
  OUT_ORDER_WITHOUT_CRATES = "OUT_ORDER_WITHOUT_CRATES",
  OUT_ORDER_CRATE_STATE_CONFLICT = "OUT_ORDER-CRATE_STATE_CONFLICT",
  OUT_ORDER_TASK_EXIST = 'OUT_ORDER_TASK_EXIST',
  INVENTORY_REPORT_ERROR_APPROVAL_NOT_ALLOWED = 'INVENTORY_REPORT_ERROR-APPROVAL_NOT_ALLOWED',
  INVENTORY_REPORT_ERROR_INVALID_TAG_RFID = 'INVENTORY_REPORT_ERROR-INVALID_TAG_RFID',
  COMMENT_ERROR_USER_NOT_ALLOWED = 'COMMENT_ERROR-USER_NOT_ALLOWED',
  COMMENT_ERROR_NOT_FOUND = "COMMENT_ERROR-NOT_FOUND",
  COMMENT_ERROR_OUT_ORDER_NOT_FOUND = "COMMENT_ERROR-OUT_ORDER_NOT_FOUND",
  PIGEONHOLE_GROUP_ERROR_ALREADY_EXISTS = 'PIGEONHOLE_GROUP_ERROR-ALREADY_EXISTS',
  PIGEONHOLE_GROUP_ERROR_NOT_FOUND = 'PIGEONHOLE_GROUP_ERROR-NOT_FOUND',
  PIGEONHOLE_GROUP_ERROR_PIGEONHOLE_NOT_FOUND = 'PIGEONHOLE_GROUP_ERROR-PIGEONHOLE_NOT_FOUND',
  INVENTORY_REPORT_ERROR_TAG_RFID_NOT_FOUND = 'INVENTORY_REPORT_ERROR-TAG_RFID_NOT_FOUND',
  INVENTORY_ERROR_NOT_FOUND = 'INVENTORY_ERROR-NOT_FOUND',
  INVENTORY_ERROR_APPROVE_INVENTORY_NOT_ALLOWED = 'INVENTORY_ERROR-APPROVE_INVENTORY_NOT_ALLOWED',
  INVENTORY_ERROR_DATA_VALIDATION = 'INVENTORY_ERROR-DATA_VALIDATION',
  PALLET_NOT_FOUND = 'PALLET_NOT_FOUND',
  OUT_ORDER_ERROR_INVALID_STATE = 'OUT_ORDER_ERROR-INVALID_STATE',
  OUT_ORDER_NOT_FOUND = 'OUT_ORDER_NOT_FOUND',
  IN_ORDER_ERROR_ALREADY_EXISTS = 'IN_ORDER_ERROR-ALREADY_EXISTS',
  IN_ORDER_ERROR_INVALID_PRODUCT = 'IN_ORDER_ERROR-INVALID_PRODUCT',
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private snackBar: MatSnackBar) { }

  openErrorSnackBar(error) {
    const beError = error.error;
    const {type} = beError;
    const message = this.getErrorMessage(type);
    this.snackBar.open(message, null, {
      duration: ERROR_MESSAGE_DURATION,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['red-snackbar'],
    });
  }
  openErrorSnackBarWithCustomMessage(message: string) {
    this.snackBar.open(message, null, {
      duration: ERROR_MESSAGE_DURATION,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['red-snackbar'],
    });
  }

  getErrorMessage(type: ErrorsEnum){
    switch (type){
      case ErrorsEnum.OUT_ORDER_STATE_CONFLICT:
        return 'O estado da ordem de saída deve ser AGUARDANDO VALIDAÇÃO ou BLOQUEADO PARA DESPACHO para criar o inventário.';
      case ErrorsEnum.USER_ERROR_NOT_FOUND:
        return 'Usuário não encontrado.';
      case ErrorsEnum.OUT_ORDER_WITHOUT_CRATES:
        return 'A ordem de saída não possui paletes.';
      case ErrorsEnum.OUT_ORDER_CRATE_STATE_CONFLICT:
        return 'Os paletes devem estar no estado PRONTO PARA DESPACHO.';
      case ErrorsEnum.OUT_ORDER_TASK_EXIST:
        return 'Já existe uma tarefa de inventário para esta ordem de saída.';
      default:
        return defaultMessage;
    }
  }
}
